import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../utils/rel';

class ThinkTank extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <ul className={styles.list}>
                {content.map(item => (
                    <li key={item.tag} className={styles.listitem}>
                        <div className={styles.hot}>
                            <div className={styles.box}>
                                <div>
                                    <a href={item.url} target="_blank" rel={rel}>
                                        <img src={item.src} width="300" height="169" />
                                    </a>
                                </div>
                                <div className={styles.wrapper}>
                                    <div className={styles.mask} />
                                    <div className={styles.details}>
                                        <h3 className={styles.title}>
                                            <a href={item.url} target="_blank" rel={rel}>
                                                {item.title}
                                            </a>
                                        </h3>
                                    </div>
                                </div>
                                <div className={styles.tip}>{item.tag}</div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        );
    }
}

export default errorBoundary(ThinkTank);
